import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { ShortUrlResolver } from './core/resolver/short-url.resolver';
import { LongUrlNavigatorComponent } from './shared/long-url-navigator/long-url-navigator.component';
import { PasswordLoginComponent } from './shared/password-login/password-login.component';

const routes: Routes = [
    {
        path: '',
        redirectTo: 'default',
        pathMatch: 'full'
    },
    {
        path: 'csr/:agentId',
        redirectTo: 'default/client-registration/:agentId'
    },
    {
        path: 'mlo-csr/:agentId',
        redirectTo: 'default/mlo-client-registration/:agentId'
    },
    {
        path: 'mlo/:shortCode',
        resolve: {longUrl: ShortUrlResolver},
        component: LongUrlNavigatorComponent
    },
    {
        path: 'chatbot',
        redirectTo: 'default/chatbot-container'
    },
    {
        path: 'csr-external/:agentId',
        redirectTo: 'default/external-client-registration/:agentId'
    },
    {
        path: 'rsr/:agentId',
        redirectTo: 'default/realtor-self-registration/:agentId'
    },
    {
        path: 'default',
        loadChildren: () => import('./modules/default/default.module').then(m => m.DefaultModule)
    },
    {
        path: 'settings',
        loadChildren: () => import('./modules/settings/settings.module').then(m => m.SettingsModule)
    },
    {
        path: 'token',
        loadChildren: () => import('./modules/token/token.module').then(m => m.TokenModule)
    },
    {
        // redirect agent to admin in case users bookmarked it
        path: 'agent',
        redirectTo: 'admin'
    },
    {
        path: 'password-login',
        component: PasswordLoginComponent
    },
    {
        path: 'admin',
        //canActivate: [LgvAuth0GuardAdmin],
        loadChildren: () => import('./modules/admin/admin.module').then(m => m.AdminModule)
    },
    {
        path: 'client',
        loadChildren: () => import('./modules/client/client.module').then(m => m.LGVClientModule)
    },
    {
        path: '**',
        redirectTo: 'default'
    }
];

@NgModule({
    // useHash supports github.io demo page, remove in your app
    imports: [
        RouterModule.forRoot(routes, {
    useHash: true,
    scrollPositionRestoration: 'enabled',
    preloadingStrategy: PreloadAllModules
})
    ],
    exports: [RouterModule]
})
export class AppRoutingModule { }
